module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="c-block cw-mb1">\r\n    <div class="c-block__title cw-mb3">\r\n        <span class="c-block__titleText row no-gutters"></span>\r\n        <span class="c-block__titleIcon" style="display:inline-table;"></span>\r\n    </div>\r\n    <div class="c-block__content" style="display: none;"><br></div>\r\n</div>';
}
return __p;
};
